/* This file is auto-generated, manual edits in this file will be overwritten! */

export const i18nKeys = {
  common: {
    errors: {
      file_too_small: 'common.errors.file_too_small',
      file_too_large: 'common.errors.file_too_large',
      too_many_files: 'common.errors.too_many_files',
      file_invalid_type: 'common.errors.file_invalid_type',
    },
    table: {
      sort: {
        asc: 'common.table.sort.asc',
        desc: 'common.table.sort.desc',
        default: 'common.table.sort.default',
      },
    },
  },
};
